/* eslint-disable no-redeclare */
import { z } from 'zod';

export const FamilyMedicalHistory = z.enum(['YES', 'NO']);

export type FamilyMedicalHistory = z.infer<typeof FamilyMedicalHistory>;
